export const OP_TYPE = {
  INCLUDE: 'include',
  NOT_INCLUDE: 'notInclude',
  EQUAL: 'equal',
  NOT_EQUAL: 'notEqual',
  BEGIN_WITH: 'beginWith',
  END_WITH: 'endWith'
};
export const OP_VALUE = {
  [OP_TYPE.INCLUDE]: 'include',
  [OP_TYPE.NOT_INCLUDE]: 'notInclude',
  [OP_TYPE.EQUAL]: 'equal',
  [OP_TYPE.NOT_EQUAL]: 'notEqual',
  [OP_TYPE.BEGIN_WITH]: 'beginWith',
  [OP_TYPE.END_WITH]: 'endWith'
};
export const create = (type, {
  name,
  value
} = {}) => {
  // 允许所有操作符
  if (!name) {
    console.warn(`[AdvSearch] 创建操作符失败，无效名称: ${name}`);
    return null;
  }

  return {
    type: 'op',
    builder: type,
    name,
    value
  };
};